export default {
  ERROR_PERMISSION_DENIED_message:
    'Sorry. You do not have permission to access the requested path. Please check the URL for typos and try again. Or, please return to the TargetX Home screen to access the appropriate app.',
  ERROR_PERMISSION_DENIED_title: 'Permission Denied',
  returnButtonLabel: 'GO HOME'
};
